import React from 'react';
import './index.css';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';
import { SetCity, SetGroup, SetOffice } from '../../actions/li';
import InputMask from 'react-input-mask';
import { sendMail } from '../../actions/callback';
import { getNotification, getErrorNotification } from '../../actions/toast';
import { closeRequestModal } from '../../actions/modals';

class EnrollChildComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      city: null,
      offices: null,
      groups: null,
      phone: '',
      contact_person: '',
      errorPhone: false,
      errorCity: false,
    };
  }

  componentDidMount() {}

  handleTextField = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    if (e.target.name === 'phone' && this.state.errorPhone) {
      this.setState({ errorPhone: false });
    }
  };

  processLessonTime(time) {
    const d = new Date(+new Date(`2021-06-07 ${time}`) + 1000 * 60 * 60);
    const _min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
    const _hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
    return `${_hours}:${_min}`;
  }

  processGroupName(item) {
    const { t } = this.props;
    const days_schema = {
      0: t('days.mon'),
      1: t('days.tue'),
      2: t('days.wed'),
      3: t('days.thu'),
      4: t('days.fri'),
      5: t('days.sat'),
      6: t('days.sun'),
    };
    return `${days_schema[item.lesson_day]} | ${
      item.lesson_time
    } - ${this.processLessonTime(item.lesson_time)}`;
  }

  render() {
    const { t } = this.props;
    const cities = this.props.list ? JSON.parse(this.props.list) : null;
    const offices = this.props.offices ? this.props.offices : null;
    const groups = this.props.groups ? this.props.groups : null;
    const mask = {
      ru: '+9 (999) 999-99-99',
      ua: '+38 (999) 999 99 99',
      md: '+373 (99) 999-999',
      by: '+375 (99) 999-99-99',
      com: '+1 (999) 999-9999',
    };
    let domain =
      document.location.hostname.split('.')[
        document.location.hostname.split('.').length - 1
      ];
    // domain = "by";
    const handleCallback = async () => {
      const { t } = this.props;
      if (!this.state.phone || this.state.phone.includes('_')) {
        this.setState({ errorPhone: true });
      } else if (!this.props.defaultCity) {
        getErrorNotification(t('messages.error_city'));
      } else {
        this.setState({ errorPhone: false });
        const res = await sendMail({
          phone: this.state.phone,
          contact_person: this.state.contact_person,
          group:
            (this.props.selectedGroup && this.props.selectedGroup.title) ||
            null,
          office:
            (this.props.selectedOffice &&
              this.props.selectedOffice.title[domain]) ||
            null,
          selectedCity: this.props.defaultCity,
        });
        if (res && res.response === 'ok') {
          getNotification(t('messages.succes_mail'));
          this.props.closeRequestModal();
        }
      }
    };
    return (
      <div className="enroll_form">
        <Grid container>
          <Grid item xs={12} className="row item full">
            {cities ? (
              <Autocomplete
                options={cities}
                value={this.props.defaultCity}
                onChange={(event, newValue) => {
                  this.props.SetCity(newValue);
                }}
                getOptionLabel={(option) => option.title[domain] || ''}
                style={{ width: '100%' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={!this.props.defaultCity}
                    label={t('form.choose_city')}
                    variant="outlined"
                  />
                )}
              />
            ) : (
              <Skeleton
                animation="wave"
                variant="text"
                width={'100%'}
                height={70}
              />
            )}
          </Grid>
          <Grid item xs={12} className="row item full">
            <Autocomplete
              options={offices || []}
              disabled={!offices}
              value={this.props.selectedOffice}
              onChange={(event, newValue) => {
                this.props.SetOffice(newValue);
              }}
              getOptionLabel={(option) =>
                option.title[domain === 'ua' ? 'ua' : 'ru'] || ''
              }
              style={{ width: '100%' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t('form.choose_office')}
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} className="row item full">
            <Autocomplete
              options={groups || []}
              disabled={!groups}
              value={this.props.selectedGroup}
              onChange={(event, newValue) => {
                this.props.SetGroup(newValue);
              }}
              getOptionLabel={(option) => this.processGroupName(option)}
              style={{ width: '100%' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t('form.choose_group')}
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} className="row item full">
            <TextField
              onChange={this.handleTextField}
              value={this.state.contact_person}
              label={t('form.contact_person')}
              name="contact_person"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} className="row item full">
            <InputMask
              mask={mask[domain]}
              onChange={this.handleTextField}
              value={this.state.phone}
              name="phone"
            >
              {() => (
                <TextField
                  onChange={this.handleTextField}
                  value={this.state.phone}
                  name="phone"
                  variant="outlined"
                  required
                  error={this.state.errorPhone}
                  label={t('form.phone_number')}
                />
              )}
            </InputMask>
          </Grid>
          <Grid item xs={12} className="row item full buttons">
            <Button onClick={handleCallback}>{t('form.send')}</Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const widthConnect = connect(
  (state) => ({
    list: state.cities && state.cities.list,
    selectedCity: state.cities && state.cities.selectedCity,
    defaultCity: state.cities && state.cities.defaultCity,
    offices: state.cities && state.cities.offices,
    groups: state.cities && state.cities.groups,
    selectedGroup: state.cities && state.cities.selectedGroup,
    selectedOffice: state.cities && state.cities.selectedOffice,
  }),
  (dispatch) =>
    bindActionCreators(
      { SetCity, SetGroup, SetOffice, closeRequestModal },
      dispatch,
    ),
);

export default withTranslation()(widthConnect(EnrollChildComponent));
